import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';

@Component({
  tag: 'moving-fibre-upgrade-message-info',
  styleUrl: 'moving-fibre-upgrade-message-info.component.scss',
  shadow: false,
  scoped: false
})
export class MovingFibreUpgradeMessageInfo implements ComponentInterface {
  @Prop() public message: string;

  render(): JSX.Element {
    return (
      <Host>
        <div class="moving-fibre-upgrade">
          <div class="moving-fibre-upgrade--container sq-message-container">
            <div innerHTML={this.message} />
          </div>
        </div>
      </Host>
    );
  }
}
